import { useAuthStore } from '@/features/auth/auth-store';
import { ProvisioningBasicFormValues } from '@/features/provisioning/provisioning-basic-form';
import { ProvisioningSchema } from '@/features/provisioning/provisioning.type';
import { apiWrapper } from '@/shared/use-api';
import { getConfig } from '@/utils/config';
import { useMutation } from '@tanstack/react-query';

export const useBasicProvisioningMutation = () => {
  const { accessToken } = useAuthStore();
  const baseUrl =
    getConfig().featureFlags.provisionOrganizationApiBaseUrl;

  return useMutation({
    mutationFn: (formValues: ProvisioningBasicFormValues) =>
      apiWrapper({
        baseUrl,
        endpoint: `/`,
        method: 'POST',
        body: formValues,
        accessToken,
        responseSchema: ProvisioningSchema,
        isPaginated: false,
      }),
    meta: {
      invalidateQueries: ['provisioning'],
      errorMessage:
        'Das Basic Upgrade konnte nicht gestartet werden.',
    },
  });
};
